// Msg #977 — Extracted from ChatPage.jsx. Room palette + accessor helpers.
// All rooms currently point at the WHITE palette per Msg #972; per-room slots
// are kept for trivial future re-enablement of per-room tints.

const _WHITE = {
  bg: '#fafaf7', panel: '#f5f5f0', header: '#8a8a7a',
  border: '#c8c8b8', text: '#2a2a1a', headerText: '#f5f5f0',
};

// Msg #987 — Professor Oak / Pokemon regions: light-blue sky, red accents.
const _POKEMON = {
  bg: '#e8f4ff', panel: '#dcefff', header: '#3a6db0',
  border: '#7fb3e3', text: '#0f2a4a', headerText: '#ffffff',
};

export const ROOM_PALETTES = {
  Night_Club: _WHITE, Inn_Brothel: _WHITE, Red_Dragon_Inn: _WHITE, Strip_Club: _WHITE,
  Desert: _WHITE, The_Barn: _WHITE, Cafe: _WHITE, Pub: _WHITE,
  Forest: _WHITE, Garden: _WHITE, Mountains: _WHITE, Oceana: _WHITE,
  Open_Seas: _WHITE, Sky_City: _WHITE, Nexus_City: _WHITE, Church: _WHITE,
  MainHall: _WHITE, OOC_Room: _WHITE, Volcanic_Rim: _WHITE, WestTower: _WHITE,
  EastTower: _WHITE,
  // Msg #987 — Pokemon rooms use the Professor Oak palette.
  Pokemon_Stadium: _POKEMON, Pokemon_Continent: _POKEMON,
};

export const DEFAULT_PALETTE = _WHITE;

// Msg #968 back-compat single-color map — points at each palette's `panel`.
export const ROOM_THEMES = Object.fromEntries(
  Object.entries(ROOM_PALETTES).map(([k, v]) => [k, v.panel])
);

export const roomThemeColor = (room, customColor) => {
  if (customColor && String(customColor).startsWith('#')) return customColor;
  return ROOM_THEMES[room] || DEFAULT_PALETTE.panel;
};

export const roomThemePalette = (room) => ROOM_PALETTES[room] || DEFAULT_PALETTE;
